import React, { useState } from "react";
import { FaEye, FaEyeSlash, FaTrash } from "react-icons/fa";
import ModalButton from "../form/ModalButton";
import SkeletonLoader from "../SkeletonLoader";
import AuditableInfo from "../AuditableInfo";
import { lowerCase } from "lodash";
import ConfirmationModal from "../../layout/modal/ConfirmationModal";
import { FaCirclePlus } from "react-icons/fa6";
import { hasPermission } from "../../../helpers/utils/AccessControlUtils";

interface CommonNotes {
    id: string;
    comment: string;
    sortOrder: number;
}

interface CommonNotesFormProps {
    data: CommonNotes[];
    title: string;
    count: number;
    type?: any;
    loading?: any
    error?: any,
    handleDelete?: any
    isLoading?: any,
    setShow?: any,
    addPermissions?: any,
    deletePermissions?: any
}

const CommonNotesForm: React.FC<CommonNotesFormProps> = ({
    data,
    title,
    type,
    count,
    loading,
    error,
    handleDelete,
    isLoading,
    setShow,
    addPermissions,
    deletePermissions
}) => {

    const iconButtonStyle = "cursor-pointer text-highlight-0 mt-0 flex-shrink-0 gap-2";
    const [selectedFileId, setSelectedFileId] = useState("");


    return (
        <div className="bg-text-1 shadow-[0_3px_10px_#0003] text-sm rounded-md  mb-2">
            <div className="flex justify-between items-center border-b bordder border-surface-7 p-2">
                <h5 className="font-semibold text-surface-0">{title} ({count})</h5>
                {addPermissions && <FaCirclePlus size={14}
                    title={"Add Note"} className="text-highlight-5" onClick={() => setShow(true)} />
                }
            </div>
            <div className='p-2'>
                {
                    (loading) ?
                        <SkeletonLoader className={"mt-2"} count={3}></SkeletonLoader> :
                        !error && data?.length === 0 ?
                            <div className="border-2 border-[rgba(0,0,0,0.1)] p-2 rounded-sm bg-text-0 ">
                                <h3 className="text-surface-0">
                                    No {lowerCase(title)} to display
                                </h3>
                            </div>
                            :

                            <div className={"overflow-y-auto max-h-32"}>
                                {!error && data && data?.map((data: any) => {
                                    return <div className="border-2 border-[rgba(0,0,0,0.1)] p-2 rounded-sm bg-text-0 sm:block md:flex justify-between">
                                        <div className="sm:block md:flex gap-2 items-start relative">
                                            <div className={"mt-1 text-lg"}>
                                                {data?.noteBody && hasPermission(["ONOT-U"]) && <ModalButton
                                                    triggerButton={data?.external ?
                                                        <FaEye className={iconButtonStyle} /> :
                                                        <FaEyeSlash
                                                            className={iconButtonStyle} />}
                                                    onOpen={() => {
                                                        setSelectedFileId(data?.id)
                                                    }}
                                                    modal={
                                                        <ConfirmationModal
                                                            show={true}
                                                            setShow={() => {
                                                            }}
                                                            title={"Change Note Visibility"}
                                                            bodyMessage={data?.external ? "Are you sure you want to make this note hidden to the customers ?" : "Are you sure you want to make this note visible to the customers ?"}
                                                            onSubmit={() => handleDelete(data.id)}
                                                            isLoading={isLoading}
                                                        />
                                                    }
                                                />}

                                                {deletePermissions && type !== "Order" && type !== "Collector" &&
                                                    <ModalButton
                                                        triggerButton={<FaTrash className={iconButtonStyle}
                                                            title={"Delete Note"} />}
                                                        modal={
                                                            <ConfirmationModal
                                                                show={true}
                                                                setShow={() => {
                                                                }}
                                                                title={"Delete " + title}
                                                                bodyMessage={"Are you sure you want to delete this note?"}
                                                                onSubmit={() => handleDelete(data.id)}
                                                                isLoading={isLoading}
                                                            />
                                                        }
                                                    />
                                                }
                                            </div>
                                            <div>  <div>
                                                <h3 className={data?.noteType === "CUSTOMER" ? 'text-[red]' : 'text-surface-2'} >{data?.message ?? data?.noteBody}</h3>
                                            </div> </div>

                                        </div>
                                        <AuditableInfo data={data} />

                                    </div>

                                })}
                            </div>
                }
            </div>
        </div>

    );
};

export default CommonNotesForm;
